import { Resource } from '__types__/v1/models/Resource';
import { ShortlistBlock } from '__types__/v1/models/Shortlist';

export function isShortlistBlockWithLegacyContactField(
  block: ShortlistBlock
): block is ShortlistBlock & { contact: Resource } {
  return 'contact' in block && block.contact !== undefined;
}
